import { useState, useEffect } from "react";
import { Button, Checkbox, Form, Input, Modal, Spin } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { updateConfigs, updateProvinces } from "scripts/reducer";
import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

const Component = ({
	configs,
	onUpdateConfigs,
	onUpdateProvinces,
	provinces,
}) => {
	const initialState = {
		cities: [],
	};
	const [state, setState] = useState(initialState);
	const { cities, loading, visible } = state;
	const { hash, pathname } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const id = parseInt(hash?.split("_").slice(-1).pop());

	const handleProvince = (id) => {
		form.setFieldsValue({ province: id });
	};

	const handleSelect = () => {
		form.validateFields().then((values) => {
			const _province = provinces.find((o) => o.id === values.province);
			const _cities = cities
				.filter((o) => values.cities.indexOf(o.id) >= 0)
				.map((o) => ({ id: o.id, name: o.name }));

			const configs = {
				cities: _cities,
				province: _province,
			};

			API.setCookie(process.env.REACT_APP_COOKIE_CONFIGS, configs);

			onUpdateConfigs(configs);

			navigate(pathname, { replace: true });
		});
	};

	const componentDidUpdate = () => {
		if (hash?.startsWith(`#${Modals.LOCATION}`)) {
			setState((prevState) => ({
				...prevState,
				loading: true,
				visible: true,
			}));

			if (id) {
				API.cities(id, { paginate: false })
					.then(({ data: cities }) => {
						setState((prevState) => ({
							...prevState,
							loading: false,
							cities,
						}));
					})
					.catch({});
			} else {
				if (provinces.length) {
					setState((prevState) => ({
						...prevState,
						loading: false,
					}));
				} else {
					API.provinces({ paginate: false })
						.then(({ data }) => {
							onUpdateProvinces(data);

							setState((prevState) => ({
								...prevState,
								loading: false,
							}));
						})
						.catch({});
				}
			}

			setTimeout(() => {
				form.setFieldsValue({
					province: configs.province.id,
					cities: configs.cities.map((o) => o.id),
				});
			}, 0);
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Modal
			className={`bk-modal-location${!loading && id ? " has-footer" : ""}`}
			footer={
				!loading && id ? (
					<>
						<Button onClick={() => navigate(-1)}>{Resources.cancel}</Button>
						<Button
							type="primary"
							onClick={handleSelect}
						>
							{Resources.confirm}
						</Button>
					</>
				) : (
					false
				)
			}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.location}
		>
			<ul className={`provinces${loading || id ? "" : " visible"}`}>
				{provinces.map((o) => (
					<li key={o.id}>
						<Link
							to={`#${Modals.LOCATION}_${o.id}`}
							onClick={() => handleProvince(o.id)}
						>
							{o.name}
						</Link>
					</li>
				))}
			</ul>

			<Form
				form={form}
				className={!loading && id ? "visible" : ""}
			>
				<Form.Item
					name="province"
					noStyle
				>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item
					name="cities"
					rules={Rules.required}
				>
					<Checkbox.Group>
						{cities
							.filter((o) => {
								return Number(o.provinceId) === id;
							})
							.map((o) => {
								return (
									<Checkbox
										value={o.id}
										key={o.id}
									>
										{o.name}
									</Checkbox>
								);
							})}
					</Checkbox.Group>
				</Form.Item>
			</Form>

			{loading && <Spin />}
		</Modal>
	);
};

export default connect(
	(state) => {
		return {
			configs: state.configs,
			provinces: state.provinces,
		};
	},
	(dispatch) => {
		return {
			onUpdateConfigs: (data) => dispatch(updateConfigs(data)),
			onUpdateProvinces: (data) => dispatch(updateProvinces(data)),
		};
	}
)(Component);
